"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadcareGifVideo = void 0;
var _constants = require("../constants.cjs");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UploadcareGifVideo = exports.UploadcareGifVideo = /*#__PURE__*/function () {
  function UploadcareGifVideo(props) {
    var _props$effects;
    _classCallCheck(this, UploadcareGifVideo);
    _defineProperty(this, "uuid", void 0);
    _defineProperty(this, "filename", void 0);
    _defineProperty(this, "mimeType", void 0);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "height", void 0);
    _defineProperty(this, "effects", void 0);
    if (props.mimeType !== 'image/gif') {
      throw new Error("Only GIF images are allowed. Given: \"".concat(props.mimeType, "\"."));
    }
    this.uuid = props.uuid;
    this.filename = props.filename;
    this.mimeType = props.mimeType;
    this.size = props.size;
    this.width = props.width;
    this.height = props.height;
    this.effects = (_props$effects = props.effects) !== null && _props$effects !== void 0 ? _props$effects : [];
  }
  return _createClass(UploadcareGifVideo, [{
    key: "format",
    value: function format(_format) {
      /** @see https://uploadcare.com/docs/image_transformations/gif2video/#gif2video-format */
      return this.withEffect("/format/".concat(_format, "/"));
    }
  }, {
    key: "quality",
    value: function quality(_quality) {
      /** @see https://uploadcare.com/docs/image_transformations/gif2video/#gif2video-quality */
      return this.withEffect("/quality/".concat(_quality, "/"));
    }
  }, {
    key: "bestQuality",
    value: function bestQuality() {
      return this.quality('best');
    }
  }, {
    key: "aspectRatio",
    get: function get() {
      return this.width / this.height;
    }
  }, {
    key: "withEffect",
    value: function withEffect(effect) {
      return new UploadcareGifVideo({
        uuid: this.uuid,
        filename: this.filename,
        mimeType: this.mimeType,
        size: this.size,
        width: this.width,
        height: this.height,
        effects: [].concat(_toConsumableArray(this.effects), [effect])
      });
    }
  }, {
    key: "cdnUrl",
    get: function get() {
      var cdnUrl = [_constants.UPLOADCARE_CDN_URL, this.uuid, 'gif2video',
      // Prepend a dash only if effects exist.
      // It doesn't matter if there's a dash at the end of URL even if there are no effects,
      // but it looks cleaner without it.
      this.effects.length === 0 ? this.effects : [''].concat(_toConsumableArray(this.effects)).join('-')].join('/');
      return "".concat(cdnUrl).concat(encodeURIComponent(this.filename));
    }
  }, {
    key: "downloadUrl",
    get: function get() {
      var downloadUrl = [_constants.UPLOADCARE_CDN_URL, this.uuid, 'gif2video', [''].concat(_toConsumableArray(this.effects), ['/inline/no/']).join('-')].join('/');
      return "".concat(downloadUrl).concat(encodeURIComponent(this.filename));
    }
  }]);
}();